import React from 'react';
import { useAuth } from '../auth/useAuth';
import useGlobalPushNotifications from '../hooks/useGlobalPushNotifications';

const GlobalPushBootstrap: React.FC = () => {
  const { user } = useAuth();
  const role = String(user?.role || '').trim().toLowerCase();
  const isStaffRole = Boolean(role) && role !== 'student';

  // These sections already initialize push notifications locally.
  const path = typeof window !== 'undefined' ? window.location.pathname : '';
  const hasLocalPushBootstrap =
    path.startsWith('/reception') ||
    path.startsWith('/marketing') ||
    path === '/mail' ||
    path.startsWith('/employee/mail');

  useGlobalPushNotifications(Boolean(user?.id) && isStaffRole && !hasLocalPushBootstrap);
  return null;
};

export default GlobalPushBootstrap;
